import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=12692a00&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=12692a00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12692a00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/var/www/app/components/FormInput.vue').default,FormTextarea: require('/var/www/app/components/FormTextarea.vue').default,Btn: require('/var/www/app/components/Btn.vue').default,ProductInfo: require('/var/www/app/components/ProductInfo.vue').default,Page: require('/var/www/app/components/Page.vue').default})
